export enum ServerTypeCode {
    USS = 'uss',
    FBU = 'fbu',
    PDC = 'pdc',
    RDG = 'rdg',
}

